import type { AppDetails, AppDetailsResponse, AppsSearchResponse } from '../../shared/types/index.js';
import { request } from './client.js';

export async function fetchAppDetails(appBundle: string): Promise<AppDetails> {
  const { app } = await request<AppDetailsResponse>(`/apps/${encodeURIComponent(appBundle)}`);
  return app;
}

export async function searchAppDetails(q: string): Promise<Array<AppDetails>> {
  const { apps } = await request<AppsSearchResponse>('/apps/search', { query: { q } });
  return apps;
}
